<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :height="333"
      border
      :edit-rules="validRules"
      @edit-closed="subTotAmount"
    >
      <template v-slot:top>
        <div class="side-frame">
          <span class="side-frame-text">
            {{ $l('order_expense_item') || '费用填报明细' }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            @click="addNewsRow()"
            v-if="!disabled"
            ><i class="el-icon-plus" />{{ $l('btn_add') || '新增' }}
          </b-button>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-danger"
            v-if="!disabled"
            @click="removeRow()"
            ><i class="el-icon-delete" />{{ $l('btn_delete') || '删除' }}
          </b-button>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_delete') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:expense="{ row }">
        <expense-select
          v-model="row.expenseCode"
          filterable
          clearable
          :placeholder="$l('tips_select_expenseName') || '请选择费用项目...'"
          :body="{ expenseBizType: 'A' }"
          @change="
            (value, item) => expenseChange({ val: { value, item }, row })
          "
          size="mini"
        />
      </template>
      <template v-slot:substituteInvoice="{ row }">
        <el-checkbox
          @change="(e) => substituteInvoiceChange({ row, value: e })"
          size="mini"
        >
          {{ $l('table_value_substituteInvoice') || '是/否' }}
        </el-checkbox>
      </template>
      <template v-slot:substituteInvoiceShow="{ row }">
        <el-checkbox
          :checked="row.substituteInvoice === '0' ? true : false"
          size="mini"
        >
          {{ $l('table_value_substituteInvoice') || '是/否' }}
        </el-checkbox>
      </template>
      <template v-slot:customer="{ row, $rowIndex }">
        <dict-select
          v-model="row.custCode"
          :selectedLabel.sync="row.custName"
          url="/master/common/dict/noReserve/customerSelect"
          filterable
          clearable
          size="mini"
          :placeholder="$l('form_placeholder_custName') || '请选择费用客户'"
          @change="customerChange({ rowIndex: $rowIndex })"
        ></dict-select>
      </template>
      <template v-slot:custOrderNo="{ row }">
        <OrderSelect
          :orderCode.sync="row.orderCode"
          :custOrderNo.sync="row.custOrderNo"
          :custCode="row.custCode"
          :placeholder="$l('tips_select_custOrderNo') || '请选择客户订单号'"
          size="mini"
        />
      </template>
      <template v-slot:originalExpenseType="{ row }">
        <dict-select
          v-model="row.originalExpenseType"
          :disabled="row.substituteInvoice === '1' || !row.substituteInvoice"
          :selectedLabel.sync="row.v_originalExpenseType"
          url="/master/common/dict/biz"
          :body="{ dictType: 'expenseType' }"
          filterable
          clearable
          size="mini"
          :placeholder="
            $l('table_placeholder_originalExpenseType') ||
              '请选择代开发票的原始费用项目'
          "
        ></dict-select>
      </template>
      <!-- TODO -->
      <template v-slot:depedit="{ row, $rowIndex }">
        <CustomerCostSector
          :ref="`costSector${$rowIndex}`"
          :depCode.sync="row.depCode"
          :displayDepCode.sync="row.displayDepCode"
          :orgDepFullName.sync="row.orgDepFullName"
          :custCode="row.custCode"
          :userCode="salesPersonCode"
          :placeholder="$l('tips_select_orgDepFullName') || '请选择分摊部门...'"
          size="mini"
        />
      </template>
      <template v-slot:depview="{ row, $rowIndex }">
        <CustomerCostSector
          :ref="`costSector${$rowIndex}`"
          :depCode.sync="row.depCode"
          :displayDepCode.sync="row.displayDepCode"
          :orgDepFullName.sync="row.orgDepFullName"
          :custCode="row.custCode"
          :userCode="salesPersonCode"
          :placeholder="$l('tips_select_orgDepFullName') || '请选择分摊部门...'"
          size="mini"
          readonly
        />
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import OrderSelect from '@/views/digital/components/order-select'
import tableColumns from './table-columns'
import { add } from '@/libs/util.number.js'
import CustomerCostSector from '@/views/digital/components/customer-cost-sector'
export default {
  components: { OrderSelect, CustomerCostSector },
  props: {
    disabled: { type: Boolean, default: false },
    userPaymentRequestCode: { type: String, default: '' },
    salesPersonCode: { type: String, default: '' },
    // depCode: { type: String, default: '' },
    // orgDepFullName: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      tableColumns: tableColumns(this),
      validRules: {
        currencyAmount: [
          {
            type: 'number',
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('tips_currency_amount_must_be_greater_than_0') ||
              '费用金额须大于0',
          },
        ],
        expenseName: [
          {
            required: true,
            message: this.$l('tips_select_expenseName') || '请选择项目费用',
          },
        ],
        custName: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('form_placeholder_custName') || '请选择费用客户',
          },
        ],
        orgDepFullName: [
          {
            required: true,
            trigger: 'change',
            message:
              this.$l('tips_select_orgDepFullName') || '请选择分摊部门...',
          },
        ],
        v_originalExpenseType: [
          {
            validator: ({ row, cellValue }) => {
              const { substituteInvoice } = row
              if (substituteInvoice === '0' && !cellValue) {
                return new Error(
                  this.$l('table_placeholder_originalExpenseType') ||
                    '请选择代开发票的原始费用项目'
                )
              }
            },
          },
        ],
      },
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.userPaymentRequestCode) return
      this.$api
        .userPaymentRequestItemListApi({
          userPaymentRequestCode: this.userPaymentRequestCode,
        })
        .then((res) => {
          this.tableData = res.body.data
        })
    },
    async addNewsRow() {
      const $itemTable = this.$refs.itemTable
      const { row: newRow } = await $itemTable.insertAt(
        { substituteInvoice: '1' },
        -1
      )

      await $itemTable.setActiveCell(newRow, 'currencyAmount')

      const tableData = this.getTableData()
      this.customerChange({ rowIndex: tableData.length - 1 })
    },
    async delRow(row) {
      this.$refs.itemTable.remove(row)
      this.subTotAmount()
    },
    getTableData() {
      const { fullData } = this.$refs.itemTable.getTableData()
      return fullData
    },
    async validate() {
      const result = await this.$refs.itemTable.validate(true).catch(() => true)
      return !result
    },
    async removeRow() {
      await this.$refs.itemTable.removeCheckboxRow()
      this.subTotAmount()
    },
    async subTotAmount() {
      const data = this.getTableData()
      const totAmount = data.reduce(
        (result, next) => add(result, next.currencyAmount),
        0
      )
      this.$emit('updateTotAmount', totAmount)
    },
    expenseChange({ val, row }) {
      const { item } = val || {}
      const { expenseCode, expenseName, expenseType, v_expenseType } =
        item || {}
      row.expenseCode = expenseCode
      row.expenseName = expenseName
      row.expenseType = expenseType
      row.v_expenseType = v_expenseType
    },
    substituteInvoiceChange({ row, value }) {
      row.substituteInvoice = value ? '0' : '1'
      row.originalExpenseType = ''
      row.v_originalExpenseType = ''
    },
    customerChange({ rowIndex }) {
      const $costSector = this.$refs[`costSector${rowIndex}`]
      if (!$costSector) return
      $costSector.clear()
    },
  },
}
</script>
